// Static asset metadata — the single source of truth for the UI.
// Adding a new asset later only requires an entry here (+ backend config).

export const OUNCE_TO_GRAM = 31.1034768;

export const KARATS = [
  { k: "24K", purity: 1.0 },
  { k: "22K", purity: 0.9167 },
  { k: "21K", purity: 0.875 },
  { k: "18K", purity: 0.75 },
  { k: "14K", purity: 0.5833 },
];

export const METAL_CURRENCIES = ["USD", "EUR", "GBP", "AED", "CHF", "JPY", "CAD", "AUD", "CNY", "SGD"];

// chartColor references CSS chart vars for theme-awareness
export const ASSET_META = {
  gold: { slug: "gold", path: "/gold", category: "metal", color: "var(--chart-1)", symbol: "gold" },
  silver: { slug: "silver", path: "/silver", category: "metal", color: "var(--chart-4)", symbol: "silver" },
  platinum: { slug: "platinum", path: "/platinum", category: "metal", color: "var(--chart-4)", symbol: "platinum" },
  bitcoin: { slug: "bitcoin", path: "/bitcoin", category: "crypto", color: "var(--chart-1)", symbol: "bitcoin" },
  ethereum: { slug: "ethereum", path: "/ethereum", category: "crypto", color: "var(--chart-2)", symbol: "ethereum" },
  xrp: { slug: "xrp", path: "/crypto/xrp", category: "crypto", color: "var(--chart-2)", symbol: "xrp" },
  solana: { slug: "solana", path: "/crypto/solana", category: "crypto", color: "var(--chart-3)", symbol: "solana" },
  bnb: { slug: "bnb", path: "/crypto/bnb", category: "crypto", color: "var(--chart-1)", symbol: "bnb" },
  cardano: { slug: "cardano", path: "/crypto/cardano", category: "crypto", color: "var(--chart-2)", symbol: "cardano" },
  dogecoin: { slug: "dogecoin", path: "/crypto/dogecoin", category: "crypto", color: "var(--chart-1)", symbol: "dogecoin" },
  brent: { slug: "brent", path: "/oil/brent", category: "energy", color: "var(--chart-3)", symbol: "brent" },
  wti: { slug: "wti", path: "/oil/wti", category: "energy", color: "var(--chart-3)", symbol: "wti" },
  natgas: { slug: "natgas", path: "/energy/natural-gas", category: "energy", color: "var(--chart-3)", symbol: "natgas" },
  eurusd: { slug: "eurusd", path: "/forex/eur-usd", category: "forex", color: "var(--chart-2)", symbol: "eurusd" },
  gbpusd: { slug: "gbpusd", path: "/forex/gbp-usd", category: "forex", color: "var(--chart-2)", symbol: "gbpusd" },
  usdjpy: { slug: "usdjpy", path: "/forex/usd-jpy", category: "forex", color: "var(--chart-2)", symbol: "usdjpy" },
  eurgbp: { slug: "eurgbp", path: "/forex/eur-gbp", category: "forex", color: "var(--chart-2)", symbol: "eurgbp" },
};

export const HOME_TICKERS = ["gold", "silver", "bitcoin", "ethereum", "brent", "wti", "eurusd"];

export const CRYPTO_LIST = ["bitcoin", "ethereum", "xrp", "solana", "bnb", "cardano", "dogecoin"];
export const METAL_LIST = ["gold", "silver", "platinum"];
export const ENERGY_LIST = ["brent", "wti", "natgas"];
export const FOREX_LIST = ["eurusd", "gbpusd", "usdjpy", "eurgbp"];

export const pathFor = (symbol) => ASSET_META[symbol]?.path || `/markets`;
export const colorFor = (symbol) =>
  getComputedStyle(document.documentElement)
    .getPropertyValue((ASSET_META[symbol]?.color || "var(--chart-1)").replace("var(", "").replace(")", ""))
    .trim();

export const PERIODS = ["24H", "7D", "1M", "6M", "1Y"];

// Heatmap universe (relative-performance grid on the market overview).
export const HEATMAP_LIST = ["gold", "silver", "bitcoin", "ethereum", "xrp", "solana", "brent", "wti", "eurusd", "gbpusd"];

// Compact currency presets used on the gold page.
export const COUNTRY_PRESETS = [
  { code: "EUR", label: "EUR", currency: "EUR" },
  { code: "GB", label: "UK · GBP", currency: "GBP" },
  { code: "US", label: "US · USD", currency: "USD" },
];

// currency per asset for display
export const displayCurrency = (asset) => asset?.quoteCurrency || "USD";
